var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.5, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 0.5 0 L 5 3.5 L 3.5 3 L 0.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 69.5 0 L 75 3.5 L 73.5 3 L 69.5 1 L 34.5 23 L 33.5 21 L 35.5 22 L 69.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 139.5 0 L 137.5 3 L 104.5 23 L 103.5 21 L 105.5 22 L 139.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 6.5 4 L 13 8.5 L 11.5 8 Q 6.9 6.8 6.5 4 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 76.5 4 L 83 8.5 L 81.5 8 Q 76.9 6.8 76.5 4 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 14.5 9 L 21 13.5 L 19.5 13 Q 14.9 11.8 14.5 9 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 84.5 9 L 91 13.5 L 89.5 13 Q 84.9 11.8 84.5 9 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 22.5 14 L 23.5 16 L 22.5 14 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 92.5 14 L 93.5 16 L 92.5 14 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 25.5 16 L 29 18.5 L 27.5 18 L 25.5 16 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 95.5 16 L 99 18.5 L 97.5 18 L 95.5 16 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 30.5 19 L 31.5 21 L 30.5 19 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 100.5 19 L 101.5 21 L 100.5 19 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 0.5 59 L 140 59.5 L 0.5 60 L 0.5 59 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 0.5 79 L 39.5 79 L 40 79.5 L 40 241 L 0 240.5 L 39 240 L 39 80.5 L 38.5 80 L 0.5 80 L 0.5 79 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 93.5 79 L 139.5 79 L 140 80.5 L 137.5 84 L 138 82.5 L 139 80.5 L 93 80 L 91.5 83 L 92 81.5 L 93.5 79 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 90.5 84 L 90 85.5 L 86.5 91 L 87 89.5 L 90.5 84 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 136.5 85 L 135.5 87 L 136.5 85 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 134.5 88 L 134 89.5 L 132.5 92 L 133 90.5 L 134.5 88 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 85.5 92 L 85 93.5 L 81.5 99 L 82 97.5 L 85.5 92 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 131.5 93 L 130.5 95 L 131.5 93 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 129.5 96 L 129 97.5 L 125.5 103 L 126 101.5 L 129.5 96 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 80.5 100 L 80 101.5 L 76.5 107 L 77 105.5 L 80.5 100 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 124.5 104 L 124 105.5 L 120.5 111 L 121 109.5 L 124.5 104 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 75.5 108 L 75 109.5 L 71.5 115 L 72 113.5 L 75.5 108 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 119.5 112 L 119 113.5 L 115.5 119 L 116 117.5 L 119.5 112 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 70.5 116 L 70 117.5 L 66.5 123 L 67 121.5 L 70.5 116 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 114.5 120 L 114 121.5 L 110.5 127 L 111 125.5 L 114.5 120 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 65.5 124 L 64.5 126 L 65.5 124 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 63.5 127 L 63 128.5 L 61.5 131 L 62 129.5 L 63.5 127 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 109.5 128 L 109 129.5 L 105.5 135 L 106 133.5 L 109.5 128 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 60.5 132 L 59.5 134 L 60.5 132 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 58.5 135 L 58 136.5 L 54.5 142 L 55 140.5 L 58.5 135 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 104.5 136 L 103.5 138 L 104.5 136 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 102.5 139 L 102 140.5 L 100.5 143 L 101 141.5 L 102.5 139 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 53.5 143 L 53 144.5 L 49.5 150 L 50 148.5 L 53.5 143 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 99.5 144 L 98.5 146 L 99.5 144 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 97.5 147 L 97 148.5 L 95.5 151 L 96 149.5 L 97.5 147 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 48.5 151 L 48 152.5 L 44.5 158 L 45 156.5 L 48.5 151 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 94.5 152 L 93.5 154 L 94.5 152 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 92.5 155 L 92 156.5 L 90 160.5 L 115 199.5 L 113 198.5 L 89 159.5 L 92.5 155 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 44.5 162 L 47 165.5 L 45 164.5 L 44.5 162 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 47.5 167 L 48.5 169 L 47.5 167 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 49.5 170 L 54 176.5 L 52 175.5 L 49.5 170 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 54.5 178 L 59 184.5 L 57 183.5 L 54.5 178 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 59.5 186 L 64 192.5 L 62 191.5 L 59.5 186 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 64.5 194 L 69 200.5 L 67 199.5 L 64.5 194 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 115.5 201 L 120 207.5 L 118 206.5 L 115.5 201 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 69.5 202 L 70.5 204 L 69.5 202 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 71.5 205 L 74 208.5 L 72 207.5 L 71.5 205 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 120.5 209 L 136 232.5 L 140 241 L 93.5 241 L 92 239.5 L 91 237.5 L 93 238.5 L 93.5 240 L 138.5 240 L 138 238.5 L 120.5 209 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 74.5 210 L 75.5 212 L 74.5 210 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 76.5 213 L 79 216.5 L 77 215.5 L 76.5 213 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 79.5 218 L 80.5 220 L 79.5 218 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 81.5 221 L 84 224.5 L 82 223.5 L 81.5 221 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 84.5 226 L 85.5 228 L 84.5 226 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,64)",
    stroke: "rgb(255,0,64)",
    strokeWidth: 1,
    opacity: 0.49411764705882355,
    d: "M 86.5 229 L 91 235.5 L 89 234.5 L 86.5 229 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,65)",
    stroke: "rgb(255,0,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 1 L 35.5 23 L 70.5 1 L 105.5 23 L 139.5 1 L 140 59 L 0 59 L 0.5 1 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,65)",
    stroke: "rgb(255,0,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 80 L 38.5 80 L 39 80.5 L 39 240 L 0.5 240 L 0 239.5 L 0 80 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,65)",
    stroke: "rgb(255,0,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93 80 L 139 80.5 L 89 160.5 L 139 239.5 L 93 240 L 47 166.5 L 44 161.5 L 44 158.5 L 93 80 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1.5 0 L 69 0.5 L 34.5 22 L 2.5 2 L 1.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 71.5 0 L 139 0.5 L 104.5 22 L 72.5 2 L 71.5 0 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 60 L 139.5 60 L 140 60.5 L 140 79 L 93.5 79 L 92 80.5 L 43 160.5 L 93 240.5 L 40 241 L 40 79.5 L 39.5 79 L 0 79 L 0 60 Z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 139.5 81 L 140 238.5 L 139 238.5 L 90 159.5 L 139.5 81 Z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmRed);
export default __webpack_public_path__ + "static/media/km-red.510002254f1ed93d81536aff47568626.svg";
export { ForwardRef as ReactComponent };